import type { PropsWithChildren } from 'react';
import cx from 'classnames';
import { HEADER_VARIANT_TYPE } from '../../header.constants';
import { useHeaderContext } from '../../context/header-context';

type MobileTopBarProps = PropsWithChildren<{
  className?: string;
}>;

export const MobileTopSection = ({ children }: MobileTopBarProps) => {
  const {
    navigation: { headerVariantType },
  } = useHeaderContext();

  const isDefaultOrMinimalVariant =
    headerVariantType === HEADER_VARIANT_TYPE.default ||
    headerVariantType === HEADER_VARIANT_TYPE.minimal;

  return (
    <div
      className={cx(
        'flex items-center',
        isDefaultOrMinimalVariant ? 'justify-end' : 'justify-between'
      )}
      data-testid="header-mobile-top-section"
    >
      {children}
    </div>
  );
};
